// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__12qW8","unreadBadge":"styles_unreadBadge__33Yx0","modalContent":"styles_modalContent__1HUIk","modal":"styles_modal__38VFt"};